import PropTypes from 'prop-types';
// third party
import { SnackbarProvider } from 'notistack';

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //
//
// The maxStack/dense/iconVariant knobs used to come from the Redux snackbar slice, which
// only ever held its own initial values (3 / false / 'usedefault') — nothing dispatched a
// change. With Redux gone (NEX-1385) they are the literals they always were.

export default function Notistack({ children }) {
  return <SnackbarProvider maxSnack={3}>{children}</SnackbarProvider>;
}

Notistack.propTypes = { children: PropTypes.any };
